'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var triggerCustomEvent = require('trigger-custom-event');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);
var notify = require('notify');
var utils = require('./utils/main');
var modal = require('./modal');

var appDom = require('./app-dom');
var dom;

var setupDom = function() {

	dom = {};
	dom.appointmentDisplay = appDom.document.find('.appointment-display');

};

var addEventHandlers = function() {

	appDom.document.on('click', '.appointment-display__cancel-btn', onCancelBtnClick);
	appDom.document.on('click', '.scheduler-modal__cancel-appointment-btn', onCancelAppointmentBtnClick);
	appDom.document.on('click', '.scheduler-modal__close-btn', onCloseBtnClick);

};

var onCloseBtnClick = function(e) {

	modal.close();

};

var onCancelBtnClick = function(e) {

	var $btn = $(this);

	e.preventDefault();

	modal.open({
		url: utils.getUrl('scheduler.cancelAppointmentModal'),
		data: {
			appointmentId: $btn.attr('data-appointment-id'),
			appointmentDate: $btn.attr('data-appointment-date')
		},
		closeOnOverlayClick: true
	});

};

var onCancelAppointmentBtnClick = function() {

	var $btn = $(this);
	
	$.ajax({
		url: utils.getUrl('scheduler.cancelAppointment'),
		method: 'POST',
		data: {
			appointmentId: $btn.attr('data-appointment-id'),
			cancelConfirmation: appDom.document.find('[name="cancelConfirmation"]').is(':checked') ? true : false
		}
	}).done(onCancelAppointmentBtnClickDone);

};

var refreshPage = function() {

	window.location.reload();

};

var onCancelAppointmentBtnClickDone = function(response) {

	if (response.status.code) {

		modal.open({
			url: utils.getUrl('scheduler.appointmentCanceled'),
			closeOnOverlayClick: true
		});

		appDom.document.on('modal_closed', refreshPage);

	} else {

		notify.show({
			target: appDom.document.find('[name="' + response.target + '"]'),
			msg: response.status.msg,
			container: '.scheduler-modal'
		});

	}

};

var init = function() {

	setupDom();

	if (dom.appointmentDisplay.length) {
		
		addEventHandlers();

	}

};

module.exports = {
	init: init
};